import { ReactNode } from 'react';
import clsx from 'clsx';

export interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
}

function Card({ children, className, padding = true, ...props }: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-lg bg-card-background',
        padding && 'p-8',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
